export const REMOVAL_REASONS = [
  { code: "manual_opt_out",      label_en: "Manual opt-out",         label_es: "Cancelación manual" },
  { code: "stop_keyword",        label_en: "STOP keyword",           label_es: "Palabra clave STOP" },
  { code: "wrong_number",        label_en: "Wrong number",           label_es: "Número equivocado" },
  { code: "landline",            label_en: "Landline",               label_es: "Línea fija" },
  { code: "deceased",            label_en: "Deceased",               label_es: "Fallecido/a" },
  { code: "do_not_contact",      label_en: "Do not contact",         label_es: "No contactar" },
  { code: "reassigned_risk",     label_en: "Reassigned number risk", label_es: "Riesgo de número reasignado" },
  { code: "duplicate",           label_en: "Duplicate",              label_es: "Duplicado" },
  { code: "invalid_consent",     label_en: "Invalid consent",        label_es: "Consentimiento inválido" },
  { code: "carrier_complaint",   label_en: "Carrier complaint",      label_es: "Queja de operador" },
  { code: "platform_complaint",  label_en: "Platform complaint",     label_es: "Queja de plataforma" },
] as const;

export type RemovalReasonCode = (typeof REMOVAL_REASONS)[number]["code"];
